import { Record } from 'immutable';
import { DELETE_TASK_SUCCESS } from '../tasks';
import {
  CREATE_SINGLE_GROUP_CONFLICT,
  CREATE_GROUP_CONFLICT,
  GROUPS_STUDENT_ALREADY_STAGED,
  GROUPS_UNDEFINED_STUDENT_RECORD } from '../groups'
import {
  UPDATE_CONFIRMEDGROUP_SUCCESS
} from '../confirmed-group'
import {
  SIGN_IN_ERROR
} from '../groups'
import { DISMISS_NOTIFICATION } from './action-types';


export const NotificationState = new Record({
  actionLabel: '',
  display: false,
  message: ''
});


export function notificationReducer(state = new NotificationState(), action) {
  switch (action.type) {
    case UPDATE_CONFIRMEDGROUP_SUCCESS:
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'Preferences Updated'
      })

    case "PREFERENCE_ALREADY_ADDED":
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'Preference already added'
      })
      
    case "SIGN_IN_ERROR":
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'Check your username/password'
      });

    case CREATE_SINGLE_GROUP_CONFLICT:
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'If you are already in a Pending or Confirmed Group you cannot form a single group'
      });

    case CREATE_GROUP_CONFLICT:
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: `Cannot Create Group: ${action.payload.email} is already in a group.`
      });

    case "CURRENT_USER_ACCEPT":
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'Invite Accepted'
      });

    case "CURRENT_USER_REJECT":
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'Invite Rejected'
      });

    case "CURRENT_USER_ALREADY_RESPONDED":
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'You can only accept or reject one time'
      });

    case "CURRENT_USER_SUBMIT_PREFS":
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'Preferences Submitted'
      });
    case DELETE_TASK_SUCCESS:
      return state.merge({
        actionLabel: 'Undo',
        display: true,
        message: 'Task deleted'
      });

    case GROUPS_STUDENT_ALREADY_STAGED:
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'You have already staged an invite to this student.'
      })

    case GROUPS_UNDEFINED_STUDENT_RECORD:
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'The student does not exist.'
      })

    case "PREFERENCE_GROUP_CAP_MISMATCH":
      return state.merge({
        actionLabel: 'Dismiss',
        display: true,
        message: 'Error: Group size and room capacity do not match'
      })
    case DISMISS_NOTIFICATION:
      return new NotificationState();

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/core/notification/reducer.js